module.exports = __webpack_public_path__ + "img/icon_bonus.3fdde239.svg";